// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
  --ion-card-background: transparent;
  box-shadow: none !important;
  padding: 0 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/layouts/auth/components/auth-card/auth-card.component.scss"],"names":[],"mappings":"AAAA;EACE,kCAAA;EACA,2BAAA;EACA,eAAA;AACF","sourcesContent":["ion-card {\r\n  --ion-card-background: transparent;\r\n  box-shadow: none !important;\r\n  padding: 0 1rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
